<template>
  <div>
    <toolbar/>
    <div class="containerFull">
      <headerbar/>
      <div class="pg-listar-boletos">
          <div class="tabelaPrincipal">
            <div class="opcoesListagemTabela">
              <form action="#" class="formularioSelecao">
                <div class="row">
                  <div class="col-md-4">
                    <label for="qtdVeiculos">Últimas</label>
                    <span class="maskSelect">
                      <select class="custom" @change="changeOptionPerPage" name="qtdVeiculos" id="qtdVeiculos">
                          <option v-for="option in optionsPerPage"
                                  :value="option"
                                  :key="option">{{ option }}</option>
                      </select>
                      <i class="fas fa-sort-down"></i>
                    </span>
                    <label for="qtdVeiculos">regras</label>
                  </div>
                  <div class="col-md-8">
                   <!-- <div class="camposPesquisa">
                      <label for="buscarVeiculos">Buscar:</label>
                      <input type="text"
                      id="buscarVeiculos"
                      name="q"
                      placeholder="Buscar por nome de serviço">
                      <button type="submit"><i class="fas fa-search"></i></button>
                    </div> -->
                  </div>
                </div>
              </form>
              <div class="checkboxs">
                <b>FILTRO</b>:
                <div v-for="service in services" style="display: inline" v-bind:key="service.code">
                  <input
                    @click="updateFilter"
                    v-bind:value="service.code"
                    v-bind:id="service.code"
                    v-bind:title="`Adicionar filtro: ${service.name}`"
                    type="checkbox"/>
                  <label v-bind:for="service.code"> {{ service.name }}</label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col" colspan="5"></th>
                  <th scope="col" colspan="4">Preço</th>
                  <th scope="col" colspan="3">Multiplicador</th>
                  <th scope="col" colspan="5">Prazo</th>
                </tr>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Serviço</th>
                  <th scope="col">Faixa</th>
                  <th scope="col">Precificação</th>
                  <th scope="col">Prcl. Máx</th>
                  <th scope="col">Instant</th>
                  <th scope="col">Express</th>
                  <th scope="col">Fast</th>
                  <th scope="col">Flex</th>
                  <th scope="col">Fin. Jurídica</th>
                  <th scope="col">Idioma ≠ PT</th>
                  <th scope="col">Pag. Parcelado</th>
                  <th scope="col">Instant</th>
                  <th scope="col">Express</th>
                  <th scope="col">Fast</th>
                  <th scope="col">Flex</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="rule in rules.data"
                  v-bind:key="rule._id"
                  @click="editRule(rule)"
                  title="Ajustar Precificação"
                >
                  <td v-html="checkServiceStatus(rule.service)"></td>
                  <td>{{ rule.service.name }}</td>
                  <td>{{ rule.minRange }}-{{ rule.maxRange || '*' }}</td>
                  <td>{{ transliterateService(rule) }}</td>
                  <td>{{ rule.maxInstallment }}</td>
                  <td>{{ findPlanByName(rule.plans, 'instant', 'value') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'express', 'value') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'fast', 'value') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'flex', 'value') }}</td>
                  <td>{{ rule.legalProposeTax }}</td>
                  <td>{{ rule.languageTax }}</td>
                  <td>{{ rule.installmentTax }}</td>
                  <td>{{ findPlanByName(rule.plans, 'instant', 'deadline') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'express', 'deadline') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'fast', 'deadline') }}</td>
                  <td>{{ findPlanByName(rule.plans, 'flex', 'deadline') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Headerbar from '@/components/Nav/Headerbar';
import Toolbar from '@/components/Nav/Toolbar';

export default {
  name: 'dashboard-rule-list',
  data() {
    return {
      filter: {
        services: [],
        perPage: 25,
        page: 1,
      },
      optionsPerPage: [
        25,
        50,
        75,
        100,
        150,
      ],
    };
  },
  async created() {
    await this.fetchService();
    await this.fetchRules();
  },
  computed: {
    rules() {
      return this.$store.state.rule.rules;
    },
    services() {
      return this.$store.state.service.services;
    },
  },
  methods: {
    transliterateService(rule) {
      return rule.fixedPrice ? 'Fixo' : `Por ${this.transliterateServiceMetric(rule.service.metric)}`;
    },
    checkServiceStatus(service) {
      const colorStatus = service.enabled ? 'color: #35572a;' : 'color: #572a35;';
      return `<i class="fas fa-circle" style="${colorStatus}"></i>`;
    },
    editRule(rule) {
      this.preAction(rule);
    },
    preAction(rule) {
      const ruleId = rule._id;
      const html = `
        <div style="text-align: left">
          Você deseja ajustar a precificação da regra: ${rule.service.name} - Faixa: ${rule.minRange}-${rule.maxRange || '*'} ?
        </div>
      `;
      this.$swal.fire({
        title: 'Atualizar Regra',
        html,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: () => this.$router.push({ name: 'dashboard>rules>edit', params: { id: ruleId } }),
      });
    },
    async updateFilter(e) {
      const value = e.target.value;
      if (e.target.checked) {
        this.filter.services.push(value);
      } else {
        this.filter.services = this.filter.services.filter(item => item !== value);
      }
      await this.fetchRules();
    },
    async changeOptionPerPage(e) {
      this.filter.perPage = e.target.value;
      await this.fetchRules();
    },
    async fetchService() {
      await this.$store.dispatch('service/fetchServices');
    },
    async fetchRules() {
      await this.$store.dispatch('rule/fetchRules', this.filter);
    },
    perPage() {
      return this.rules.perPage;
    },
  },
  components: {
    Toolbar,
    Headerbar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Rules/List.vue